import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types';
import {
  Box,
  Text,
  HStack
} from "@chakra-ui/react";

// icons
import { AvailableIcons } from './Icons/AvailableIcons';

export const MainNavMenuItem = (props) => {
  const { index, navlinkTo, itemText, itemIcon, isAlert = false } = props

  // console.log(' 🐞 MainNavMenuItem render:', { itemText, isAlert, itemIcon }); // Debug log

  // const renderIcon = (icon, index, isNavActive, isNavPending, isAlertItem = false) => {
  //   const pendingNav = (isNavPending) ? "" : "navlink-text"
  //   const iconClassName = (isNavActive) ? "navlink-text-selected" : pendingNav
    
  //   console.log(' 🐞 renderIcon called:', { isNavActive, isAlertItem, icon }); // Debug log
    
  //   // SIMPLE COLOR LOGIC - let's make this very explicit
  //   let iconColor;
  //   if (isNavActive) {
  //     iconColor = 'var(--dark-text-white)'; // White when active
  //     console.log('Setting color: white (active)');
  //   } else if (isAlertItem) {
  //     iconColor = 'var(--error-red)'; // Red when alert
  //     console.log('Setting color: red (alert)');
  //   } else {
  //     iconColor = 'var(--dark-gold-primary)'; // Gold when normal
  //     console.log('Setting color: gold (normal)');
  //   }
    
  //   return (
  //     <AvailableIcons 
  //       key={'_i_'+index} 
  //       boxSize={'18px'} 
  //       iconRef={icon} 
  //       color={iconColor}
  //       bgcolor={isAlertItem ? 'var(--error-red-bg)' : null}
  //       className={iconClassName} />
  //   )
  // }

  const renderIcon = (icon, index, isNavActive, isNavPending, isAlertItem = false) => {
    let iconColor;
    
    if (isNavActive) {
      iconColor = 'var(--dark-text-white)';
    } else if (isAlertItem) {
      iconColor = 'var(--error-red)';
    } else {
      iconColor = 'var(--dark-gold-primary)';
    }
    
    return (
      <AvailableIcons 
        key={'_i_'+index} 
        boxSize={'18px'} 
        iconRef={icon} 
        color={iconColor}
      />
    )
  }

  return(
    <NavLink key={`_n_${index}`} to={`${navlinkTo}`}>
      {({ isActive, isPending }) => {
        // console.log(' 🐞 NavLink render:', { itemText, isActive, isPending, isAlert }); // Debug log
        let boxClassName, textClassName;
        
        if (isActive) {
          boxClassName = "navlink-selected";
          textClassName = "navlink-text-selected";
        } else if (isAlert) {
          boxClassName = "navlink-alert";
          textClassName = "navlink-text-alert";
        } else if (isPending) {
          boxClassName = "";
          textClassName = "";
        } else {
          boxClassName = "navlink";
          textClassName = "navlink-text";
        }

        return (
          <Box 
            key={`_b1_${index}`}
            className={boxClassName}>
            <HStack 
              key={`_hs_${index}`}
              mt={'9px'}
              align={'left'}>
              <Box 
                key={`_bs_${index}`}
                marginLeft={'8px'} 
                marginRight={'2px'}>
                  {renderIcon(itemIcon, index, isActive, isPending, isAlert)}
              </Box>
              <Text 
                key={`_t_${index}`} 
                className={textClassName}>
                {itemText}
              </Text>
            </HStack>
          </Box>
        );
      }}
    </NavLink>
  )
}

MainNavMenuItem.propTypes = {
  index: PropTypes.number.isRequired,
  navlinkTo: PropTypes.string.isRequired,
  itemText: PropTypes.string.isRequired,
  itemIcon: PropTypes.string.isRequired,
  isAlert: PropTypes.bool,
};

MainNavMenuItem.defaultProps = {
  isAlert: false,
};